<template>
  <div
    class="w-auto collapse navbar-collapse"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse navText="대시보드" :to="{ name: 'Dashboard' }">
          <template #icon>
            <dashboard />
          </template>
        </sidenav-collapse>
      </li>
      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          데이터 관리
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="업무장소" :to="{ name: 'BizLocations' }">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="스캔장소" :to="{ name: 'ReadPoints' }">
          <template #icon>
            <read-point />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="재료관리" :to="{ name: 'RawMaterials' }">
          <template #icon>
            <materials />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="제품정보" :to="{ name: 'Products' }">
          <template #icon>
            <product />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="운송수단" :to="{ name: 'Vehicles' }">
          <template #icon>
            <truck />
          </template>
        </sidenav-collapse>
      </li>
      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          EPCIS 이벤트
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="이벤트 생성" :to="{ path: '/eventCreate' }">
          <template #icon>
            <event-list />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="이벤트 조회" :to="{ name: 'EventList' }">
          <template #icon>
            <event-search />
          </template>
        </sidenav-collapse>
      </li>
      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          제품 추적 및 조회
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="제품이력 조회" :to="{ path: '/productTrace' }">
          <template #icon>
            <trace />
          </template>
        </sidenav-collapse>
      </li>
      <li class="mt-3 nav-item" v-if="isAdmin()">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          시스템 관리
        </h6>
      </li>
      <li class="nav-item" v-if="isAdmin()">
        <sidenav-collapse navText="사용자 관리" :to="{ name: 'Users' }">
          <template #icon>
            <customerSupport />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="isAdmin()">
        <sidenav-collapse navText="제조사 관리" :to="{ name: 'Manufacturer' }">
          <template #icon>
            <settings />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="isAdmin()">
        <sidenav-collapse navText="접속이력 관리" :to="{ name: 'WebLogList' }">
          <template #icon>
            <foot-print />
          </template>
        </sidenav-collapse>
      </li>
      <!-- <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          개발메뉴
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="이벤트 조회" :to="{ name: 'EventList' }">
          <template #icon>
            <settings />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="이벤트 생성" :to="{ name: 'EventSave' }">
          <template #icon>
            <settings />
          </template>
        </sidenav-collapse>
      </li> -->


    </ul>
  </div>
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import Office from "../../components/Icon/Office.vue";
import Settings from "../../components/Icon/Settings.vue";
import CustomerSupport from "../../components/Icon/CustomerSupport.vue";
import Truck from "../../components/Icon/Truck.vue";
import Product from "../../components/Icon/Product.vue";
import Materials from "../../components/Icon/Materials.vue";
import ReadPoint from "../../components/Icon/ReadPoint.vue";
import Dashboard from "../../components/Icon/Dashboard.vue";
import EventList from "../../components/Icon/EventList.vue";
import EventSearch from "../../components/Icon/EventSearch.vue";
import Trace from "../../components/Icon/Trace.vue";
import FootPrint from "../../components/Icon/FootPrint.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
    };
  },
  components: {
    SidenavCollapse,
    Office,
    Settings,
    CustomerSupport,
    Truck,
    Product,
    Materials,
    ReadPoint,
    Dashboard,
    EventList,
    EventSearch,
    Trace,
    FootPrint,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
  },
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.g-sidenav-mini .sidenav h6 {
  display: none !important;
}

#sidenav-collapse-main {
  flex: 1 1 auto;     /* 부모(aside)의 남은 높이를 차지 */
  min-height: 0;      /* flex 자식이 실제로 줄어들 수 있게 */
  overflow-y: auto;   /* ✅ 세로 스크롤 */
  overflow-x: hidden; /* 가로 스크롤 숨김 */
}

/* mini 모드에서 섹션 타이틀 숨김 유지 */
.g-sidenav-mini .sidenav h6 { display: none !important; }
.disabled { pointer-events: none; opacity: .5; }



</style>